import React from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { NetworkBadges } from './NetworkBadges';

export const NetworkProfile = ({ network }) => (
  <div>
    {/* Hero Banner with Image */}
    {network.imageUrl && (
      <div
        className="network-hero-banner"
        style={{
          backgroundImage: 'url(' + network.imageUrl + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          height: '300px',
          borderRadius: '12px 12px 0 0',
          position: 'relative',
          marginBottom: '60px'
        }}
      >
        <div style={{
          position: 'absolute',
          bottom: '-40px',
          left: '40px',
          background: 'white',
          padding: '15px',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
        }}>
          {network.logoUrl && (
            <img
              src={network.logoUrl}
              alt={network.name}
              style={{ height: '80px', width: 'auto' }}
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          )}  
        </div>
      </div>
    )}

    {/* Network Content */}
    <div className="p-4">
      {/* Title and Badges */}
      <div className="mb-4">
        <h1 className="display-5 fw-bold mb-3">{network.name}</h1>
        <div className="mb-3">
          <NetworkBadges network={network} />
        </div>
        {network.subDomain && (
          <p className="text-muted">
            <code style={{ fontSize: '0.9rem', padding: '4px 8px', background: '#f8f9fa', borderRadius: '4px' }}>
              SubDomain: {network.subDomain}
            </code>
          </p>
        )}
        {network.code && (
          <p className="text-muted">
            <code style={{ fontSize: '0.9rem', padding: '4px 8px', background: '#f8f9fa', borderRadius: '4px' }}>
              Code: {network.code}
            </code>
          </p>
        )}
      </div>

      {/* Short Description */}
      {network.shortDescription && (
        <div className="mb-4 p-4" style={{ background: '#f8f9fa', borderRadius: '8px', borderLeft: '4px solid #1a73e8' }}>
          <h5 className="fw-bold mb-2">Overview</h5>
          <p className="lead mb-0">{network.shortDescription}</p>
        </div>
      )}

      {/* Description */}
      {network.description && network.description !== network.shortDescription && (
        <div className="mb-4">
          <h4 className="fw-bold mb-3">About</h4>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#495057' }}>
            {network.description}
          </p>
        </div>
      )}

      {/* Long Description */}
      {network.longDescription && network.longDescription !== network.description && (
        <div className="mb-4">
          <h4 className="fw-bold mb-3"></h4>
          <div style={{ fontSize: '1rem', lineHeight: '1.8', color: '#495057' }}>
            {network.longDescription.split('\n').map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        </div>
      )}

      {/* Network Statistics */}
      <div className="row g-3 mb-4">
        <div className="col-md-4">
          <div className="p-3 border rounded text-center">
            <div className="h2 mb-0 text-primary">{network.businessNetworkID}</div>
            <div className="small text-muted">Network ID</div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="p-3 border rounded text-center">
            <div className="h2 mb-0 text-success">
              {network.isPublic ? <FaCheck /> : <FaTimes />}
            </div>
            <div className="small text-muted">Public Access</div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="p-3 border rounded text-center">
            <div className="h2 mb-0 text-info">
              {network.isVerified ? <FaCheck /> : <FaTimes />}
            </div>
            <div className="small text-muted">Verified</div>
          </div>
        </div>
      </div>

      {/* Technical Details */}
      <div className="mb-4">
        <h4 className="fw-bold mb-3">Technical Information</h4>
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="border-start border-4 border-primary ps-3">
              <div className="small text-muted">Organization ID</div>
              <div className="fw-bold">{network.organizationID || 'N/A'}</div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="border-start border-4 border-secondary ps-3">
              <div className="small text-muted">Record Type</div>
              <div className="fw-bold">{network.recordTypeID || 'N/A'}</div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="border-start border-4 border-success ps-3">
              <div className="small text-muted">Network Type</div>
              <div className="fw-bold">{network.businessNetworkTypeID || 'Not Specified'}</div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="border-start border-4 border-info ps-3">
              <div className="small text-muted">Category</div>
              <div className="fw-bold">{network.businessNetworkCategoryID || 'Not Specified'}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
